import { Component, OnInit, Input, OnDestroy, ElementRef, Output } from '@angular/core';
import { TabsComponent } from '../tabs/tabs.component';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    standalone: false
})
export class TabComponent implements OnInit, OnDestroy {
  private readonly _elementRef: ElementRef;

  private _isActive: boolean;
  private _isGrowrTabComponent = false;
  private _disabled = false;

  @Input('label')
  public label: string;

  @Input('icon')
  public icon: string;

  @Input('tabContext')
  public tabContext: any;

  @Output() tabClicked = new EventEmitter<string>();


  public get disabled(): boolean {
    return this._disabled;
  }

  @Input('disabled')
  public set disabled(value: boolean) {
    this._disabled = value;
  }

  public get isGrowrTabComponent(): boolean {
    return this._isGrowrTabComponent;
  }

  @Input('isGrowrTabComponent')
  public set isGrowrTabComponent(value: boolean) {
    this._isGrowrTabComponent = value;

    if(value) {
      this._elementRef.nativeElement.style.backgroundColor  = '#1f2851';
    }
  }

  public get isActive(): boolean {
    return this._isActive;
  }

  @Input('isActive')
  public set isActive(value: boolean) {
    this._isActive = value;

    if(value) {
      this._elementRef.nativeElement.style.display = 'flex';
    }
    else {
      this._elementRef.nativeElement.style.display = 'none';
    }
  }

  constructor(parent: TabsComponent, elementRef: ElementRef) {
    this._elementRef = elementRef;

    this.isActive = false;

    parent.addTab(this);
  }

  public ngOnInit(): void {
  }

  public ngOnDestroy(): void {
  }
}
